import { useEffect } from 'react';
import { useAgentForgeStore } from '../stores';

const generateSessionId = (): string =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `session-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

const isToggleShortcut = (event: KeyboardEvent): boolean =>
  event.key.toLowerCase() === 'j' && (event.metaKey || event.ctrlKey);

// Cmd+J (Mac) / Ctrl+J (Windows/Linux):
//  • no active session → opens a new floating session
//  • panel visible (floating or fullscreen) → minimizes
//  • minimized or docked with an active session → re-opens floating
export const useBarKeyboardShortcut = (): void => {
  const setMode = useAgentForgeStore((s) => s.setMode);
  const openTab = useAgentForgeStore((s) => s.openTab);

  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if (!isToggleShortcut(event)) return;
      event.preventDefault();
      const { mode, activeSessionId } = useAgentForgeStore.getState();
      if (!activeSessionId) {
        openTab({
          sessionId: generateSessionId(),
          title: 'New chat',
          status: 'idle',
          createdAt: new Date().toISOString(),
        });
        setMode('floating');
        return;
      }
      if (mode === 'floating' || mode === 'fullscreen') {
        setMode('minimized');
      } else {
        setMode('floating');
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [setMode, openTab]);
};
